import { render, staticRenderFns } from "./CellularUsageInfo.vue?vue&type=template&id=0951fb0f&"
import script from "./CellularUsageInfo.vue?vue&type=script&lang=js&"
export * from "./CellularUsageInfo.vue?vue&type=script&lang=js&"
import style0 from "./CellularUsageInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports